import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { Http, Headers, RequestOptionsArgs, Response, RequestOptions } from '@angular/http';
import { REST_API_REQUEST_CALL_URL, Util } from '../../utils/index';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { AlertService, AuthenticationService } from 'app/services';

@Component({
  templateUrl: 'main.container.html'
})




export class MainContainer {

  constructor(
    private apiService: ApiService, private http: Http, private router: Router, private cookieService: CookieService,
    private auth: AuthenticationService,
    private alertService: AlertService,
  ) {
    if (!localStorage.getItem('currentUser')) {
      this.apiService.getToken(res => {
        if (localStorage.getItem('currentUser')) {
          return true;
        } else {
          this.alertService.error('접속 권한이 없는 사용자입니다.');
          setTimeout(() => {
            this.auth.logout();
          }, 2000);
        }
      });
    }
  }

  emailTest() {
    // this.apiService.post(REST_API_REQUEST_CALL_URL.BASE_URL + 'corp/employee/email', {email:'heechan25@tradlinx.com'}).subscribe();
  }
}


// WEBPACK FOOTER //
// ./src/app/containers/main/main.container.ts